import { IContentPlaylist } from './IContentPlaylist';
import { IMasterPlaylistData } from './IMasterPlaylistData';
import { IMasterPlaylistParserHelper } from './IMasterPlaylistParserHelper';
import { MASTER_PLAYLIST_VERSION_REGEX } from './DualHlsConstants';
import { MasterPlaylistParserHelperV2 } from './MasterPlaylistParserHelperV2';
import { MasterPlaylistParserHelperV4 } from './MasterPlaylistParserHelperV4';

export class MasterPlaylistParser {
	public static parse(playlistUrl: string, playlistString: string, queryParms?: { [key: string]: any }): IMasterPlaylistData {
		//detect the playlist version and leverage appropriate helper class
		const playlistVersion: string = MasterPlaylistParser.getPlaylistVersion(playlistString);
		const parserHelper: IMasterPlaylistParserHelper = MasterPlaylistParser.getPlaylistParserHelper(playlistVersion);
		const isContentTrackedInMasterPlaylist: boolean = !!parserHelper.getContentPlaylists;

		return {
			contentPlaylists: isContentTrackedInMasterPlaylist ?
				parserHelper.getContentPlaylists(playlistUrl, playlistString) :
				new Map<string, IContentPlaylist>(),
			isContentTrackedInMasterPlaylist,
			playlistVersion,
			speakerPlaylist: parserHelper.getSpeakerPlaylistUrl(playlistUrl, playlistString, queryParms)
		};
	}

	public static getPlaylistVersion(playlistString: string): string {
		const playlistVersionMatches = playlistString.match(MASTER_PLAYLIST_VERSION_REGEX);

		return playlistVersionMatches && playlistVersionMatches.length === 2 ? playlistVersionMatches[1] : '1.0';
	}

	public static getPlaylistParserHelper(playlistVersion: string): IMasterPlaylistParserHelper {
		switch (playlistVersion) {
			case '4.0':
				return MasterPlaylistParserHelperV4;

			default: // handles v2 and v1
				return MasterPlaylistParserHelperV2;
		}
	}
}
